import { ChildProps } from '@/common/util/props'

const ContentSideFrame = ({ children }: ChildProps) => {
  return <div className='flex w-full items-start justify-center gap-4'>{children}</div>
}

export default ContentSideFrame
